export const bedroomOptions = [
  {
    text: "1 Bedroom",
    value: 1
  },
  {
    text: "2 Bedrooms",
    value: 2
  },
  {
    text: "3 Bedrooms",
    value: 3
  },
  {
    text: "4 Bedrooms",
    value: 4
  },
  {
    text: "5 Bedrooms",
    value: 5
  },
  {
    text: "6 Bedrooms",
    value: 6
  }
];
export const bathroomOptions = [
  {
    text: "1 Bathroom",
    value: 1
  },
  {
    text: "2 Bathrooms",
    value: 2
  },
  {
    text: "3 Bathrooms",
    value: 3
  },
  {
    text: "4 Bathrooms",
    value: 4
  },
  {
    text: "5 Bathrooms",
    value: 5
  },
  {
    text: "6 Bathrooms",
    value: 6
  }
];
export const timeOptions = [
  {
    text: "7 AM",
    value: "7:00"
  },
  {
    text: "8 AM",
    value: "8:00"
  },
  {
    text: "9 AM",
    value: "9:00"
  },
  {
    text: "10 AM",
    value: "10:00"
  },
  {
    text: "11 AM",
    value: "11:00"
  },
  {
    text: "12 Noon",
    value: "12:00"
  },
  {
    text: "1 PM",
    value: "13:00"
  },
  {
    text: "2 PM",
    value: "14:00"
  },
  {
    text: "3 PM",
    value: "15:00"
  },
  {
    text: "4 PM",
    value: "16:00"
  },
  {
    text: "5 PM",
    value: "17:00"
  },
  {
    text: "6 PM",
    value: "18:00"
  },
  {
    text: "7 PM",
    value: "19:00"
  },
  {
    text: "8 PM",
    value: "20:00"
  }
];
export const stateList = [
  { name: "ALABAMA", abbreviation: "AL" },
  { name: "ALASKA", abbreviation: "AK" },
  { name: "AMERICAN SAMOA", abbreviation: "AS" },
  { name: "ARIZONA", abbreviation: "AZ" },
  { name: "ARKANSAS", abbreviation: "AR" },
  { name: "CALIFORNIA", abbreviation: "CA" },
  { name: "COLORADO", abbreviation: "CO" },
  { name: "CONNECTICUT", abbreviation: "CT" },
  { name: "DELAWARE", abbreviation: "DE" },
  { name: "DISTRICT OF COLUMBIA", abbreviation: "DC" },
  { name: "FEDERATED STATES OF MICRONESIA", abbreviation: "FM" },
  { name: "FLORIDA", abbreviation: "FL" },
  { name: "GEORGIA", abbreviation: "GA" },
  { name: "GUAM", abbreviation: "GU" },
  { name: "HAWAII", abbreviation: "HI" },
  { name: "IDAHO", abbreviation: "ID" },
  { name: "ILLINOIS", abbreviation: "IL" },
  { name: "INDIANA", abbreviation: "IN" },
  { name: "IOWA", abbreviation: "IA" },
  { name: "KANSAS", abbreviation: "KS" },
  { name: "KENTUCKY", abbreviation: "KY" },
  { name: "LOUISIANA", abbreviation: "LA" },
  { name: "MAINE", abbreviation: "ME" },
  { name: "MARSHALL ISLANDS", abbreviation: "MH" },
  { name: "MARYLAND", abbreviation: "MD" },
  { name: "MASSACHUSETTS", abbreviation: "MA" },
  { name: "MICHIGAN", abbreviation: "MI" },
  { name: "MINNESOTA", abbreviation: "MN" },
  { name: "MISSISSIPPI", abbreviation: "MS" },
  { name: "MISSOURI", abbreviation: "MO" },
  { name: "MONTANA", abbreviation: "MT" },
  { name: "NEBRASKA", abbreviation: "NE" },
  { name: "NEVADA", abbreviation: "NV" },
  { name: "NEW HAMPSHIRE", abbreviation: "NH" },
  { name: "NEW JERSEY", abbreviation: "NJ" },
  { name: "NEW MEXICO", abbreviation: "NM" },
  { name: "NEW YORK", abbreviation: "NY" },
  { name: "NORTH CAROLINA", abbreviation: "NC" },
  { name: "NORTH DAKOTA", abbreviation: "ND" },
  { name: "NORTHERN MARIANA ISLANDS", abbreviation: "MP" },
  { name: "OHIO", abbreviation: "OH" },
  { name: "OKLAHOMA", abbreviation: "OK" },
  { name: "OREGON", abbreviation: "OR" },
  { name: "PALAU", abbreviation: "PW" },
  { name: "PENNSYLVANIA", abbreviation: "PA" },
  { name: "PUERTO RICO", abbreviation: "PR" },
  { name: "RHODE ISLAND", abbreviation: "RI" },
  { name: "SOUTH CAROLINA", abbreviation: "SC" },
  { name: "SOUTH DAKOTA", abbreviation: "SD" },
  { name: "TENNESSEE", abbreviation: "TN" },
  { name: "TEXAS", abbreviation: "TX" },
  { name: "UTAH", abbreviation: "UT" },
  { name: "VERMONT", abbreviation: "VT" },
  { name: "VIRGIN ISLANDS", abbreviation: "VI" },
  { name: "VIRGINIA", abbreviation: "VA" },
  { name: "WASHINGTON", abbreviation: "WA" },
  { name: "WEST VIRGINIA", abbreviation: "WV" },
  { name: "WISCONSIN", abbreviation: "WI" },
  { name: "WYOMING", abbreviation: "WY" }
].map(val => {
  return { text: val.abbreviation, value: val.abbreviation };
});
export const DAY_FORMAT = "MM/DD/YYYY";



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/consts/contactConsts.js